import React from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";

const Calendar = ({ events }) => {
  return (
    <div className="w-full">
      <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]}
        initialView="dayGridMonth"
        height="420px"
        events={events}
        headerToolbar={{
          left: "prev,next",
          center: "title",
          right: "",
        }}
        dayHeaderClassNames={(arg) => {
          if (arg.date.getDay() === 0) {
            return ["text-red-700 bg-red-50 font-semibold"];
          }
          if (arg.date.getDay() !== 0) {
              return ["text-green-900 bg-green-50 font-semibold"];
            }
          return [];
        }}
        dayCellClassNames={(arg) => {
          // Sunday = 0
          if (arg.date.getDay() === 0) {
            return ["bg-red-50 text-red-700"];
          }
          return [];
        }}
        dayMaxEvents={3}
        eventContent={(arg) => {
          const { extendedProps } = arg.event;
          const fullTitle = extendedProps.description;
          return (
            <div
              className="truncate px-1 py-0.5 text-xs rounded-md"
              title={fullTitle}
              style={{
                backgroundColor: arg.event.backgroundColor,
                color: arg.event.textColor,
                borderRadius: "0.375rem",
                padding: "2px 4px",
              }}
            >
              {fullTitle}
            </div>
          );
        }}
      />
    </div>
  );
};

export default Calendar;